// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1FArC","content":"LoadingAlert_content__3WeRc"};